<div class="loader-wraper" *ngIf="loaderService.getLoading()">
    <div class="loader">

    </div>
</div>
